import callWindowFunction from "./callWindowFunction";
import { userTypes } from "../consts";

const sendUserTypeUpdateMessage = (type, atiId) => {
  const data = type === userTypes.USER ? { atiId } : {};

  callWindowFunction("publishToEventBus", [
    {
      subject: "frontUserTypeUpdate",
      destination: "exceptThisTab",
      body: { type, data },
    },
  ]);
};

export default sendUserTypeUpdateMessage;
